import { Transaction } from '@app/models/payroll/company/transaction.model';
import { CheckListFilter } from '@app/modules/table/classes/column-filters/check-list/check-list-filter.class';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

const STATUSES = {
    new: 'table.transactions.statuses.new',
    funded: 'table.transactions.statuses.funded',
    sent: 'table.transactions.statuses.sent',
    complete: 'table.transactions.statuses.complete',
    failed: 'table.transactions.statuses.failed',
    nsf: 'table.transactions.statuses.nsf',
};

export class StatusColumn extends Column {
    title = 'table.transactions.status';
    type: CellDisplay = CellDisplay.string;
    sortable = true;
    sortField = 'status';
    filters = [
        new CheckListFilter(
            'status',
            Object.entries(STATUSES).map(([value, label]) => ({ label, value }))
        ),
    ];

    getDisplayPropertyValue(object: Transaction): string {
        return STATUSES[object.status];
    }
}
